// HACK (jscheel): We seem to be inconsistent in our usage and capitalization
// of the shopify enums. Therefore we copy all enums to lowercase as well as
// uppercase, and append multiple fulfillment enumns into the same lookup table.
function includeLowerCaseKey(obj) {
  return Object.keys(obj).reduce((memo, key) => {
    const val = obj[key]
    // eslint-disable-next-line no-param-reassign
    memo[key] = val
    // eslint-disable-next-line no-param-reassign
    memo[key.toLowerCase()] = val
    return memo
  }, {})
}
export const ORDER_DISPLAY_FINANCIAL_STATUS_TEXT = includeLowerCaseKey({
  AUTHORIZED: 'Authorized',
  EXPIRED: 'Expired',
  PAID: 'Paid',
  PARTIALLY_PAID: 'Partially paid',
  PARTIALLY_REFUNDED: 'Partially refunded',
  PENDING: 'Pending',
  REFUNDED: 'Refunded',
  VOIDED: 'Voided',
})

export const FULFILLMENT_DISPLAY_STATUS_TEXT = includeLowerCaseKey({
  CANCELED: 'Canceled',
  CONFIRMED: 'Confirmed',
  DELIVERED: 'Delivered',
  FAILURE: 'Failure',
  FULFILLED: 'Fulfilled',
  IN_TRANSIT: 'In transit',
  LABEL_PRINTED: 'Label printed',
  LABEL_PURCHASED: 'Label purchased',
  LABEL_VOIDED: 'Label voided',
  MARKED_AS_FULFILLED: 'Marked as fulfilled',
  NOT_DELIVERED: 'Not delivered',
  OUT_FOR_DELIVERY: 'Out for delivery',
  PICKED_UP: 'Picked up',
  READY_FOR_PICKUP: 'Ready for pickup',
  SUBMITTED: 'Submitted',

  // Other statuses
  IN_PROGRESS: 'In progress',
  ON_HOLD: 'On hold',
  OPEN: 'Open',
  PARTIALLY_FULFILLED: 'Partially fulfilled',
  PENDING_FULFILLMENT: 'Pending fulfillment',
  RESTOCKED: 'Restocked',
  SCHEDULED: 'Scheduled',
  UNFULFILLED: 'Unfulfilled',
})

export const CUSTOMER_MARKETING_OPT_IN_LEVEL = includeLowerCaseKey({
  CONFIRMED_OPT_IN: 'Confirmed opt-in',
  SINGLE_OPT_IN: 'Single opt-in',
  confirmed_opt_in: 'Confirmed opt-in',
  single_opt_in: 'Single opt-in',
})
